"use client";

import { ReactQueryClientProvider } from "@/lib/query-client-provider";
import GlobalErrorBoundary from "@/components/features/shared/GlobalErrorBoundary";
import { TranslationProvider } from "@/context/TranslationContext";
import { ThemeProvider } from "next-themes";
import { useAiChatNavigation } from "@/components/hooks/ai-chat/useAiChatNavigation.hook";
import LeaveAiChatDialog from "@/components/features/shared/Modal/leave-ai-chat-dialog";

export function Providers({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  const isProduction = process.env.PUBLIC_NODE_ENV === "production";

  const {
    showLeaveDialog,
    setShowLeaveDialog,
    handleLeaveConfirm,
    handleCancelLeave,
  } = useAiChatNavigation();

  return (
    <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false} storageKey="open-takt-theme">
      <ReactQueryClientProvider>
        <TranslationProvider>
          {isProduction ? (
            <GlobalErrorBoundary>{children}</GlobalErrorBoundary>
          ) : (
            children
          )}
          <LeaveAiChatDialog
            open={showLeaveDialog}
            onOpenChange={setShowLeaveDialog}
            onConfirm={handleLeaveConfirm}
            onCancel={handleCancelLeave}
          />
        </TranslationProvider>
      </ReactQueryClientProvider>
    </ThemeProvider>
  );
}
